module.exports = __webpack_public_path__ + "static/media/2023-Sub-Exclusive-Feature-Banner-sm@1x.43b07569.webp";